import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import logo from '../assets/valor-logo.png';

const Nav = ({ darkMode = false }) => {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    // Set initial scroll state
    setScrolled(window.scrollY > 12);
    
    const handleScroll = () => {
      setScrolled(window.scrollY > 12);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navClass = `nav ${darkMode ? 'on-dark' : ''} ${scrolled ? 'scrolled' : ''}`;

  return (
    <header className={navClass} id="nav">
      <div className="nav-inner">
        <Link to="/" className="brand">
          <img src={logo} alt="Valor Technyx" />
        </Link>
        <nav className="nav-links">
          <Link to="/valor-os">Valor OS</Link>
          <Link to="/counterops">CounterOps</Link>
          <div className="nav-item">
            <span className="nav-trigger">Apps</span>
            <div className="submenu">
              <div className="submenu-card">
                <div className="submenu-eyebrow">Apps</div>
                <div className="submenu-list">
                  <Link to="/apps#customer-app">
                    Customer App
                    <span className="desc">Ship, track, and pay from one app.</span>
                  </Link>
                  <Link to="/apps#track-trace">
                    Track &amp; Trace
                    <span className="desc">Pickup, delivery, and proof of delivery.</span>
                  </Link>
                </div>
              </div>
            </div>
          </div>
          <Link to="/about">About</Link>
          <Link to="/contact">Contact</Link>
        </nav>
        <Link to="/contact" className="btn btn-dark btn-sm">
          Request Briefing <span className="arrow">→</span>
        </Link>
      </div>
    </header>
  );
};

export default Nav;
